import React, { useMemo, useState } from 'react'
import { InputGroup, InputGroupAddon } from 'reactstrap'
import * as Icon from 'react-feather'
import DateTimePicker from '~/components/DateTimePicker'
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
import { useSelector } from 'react-redux'
import { format, isAfter } from 'date-fns'
import { FormattedMessage, useIntl } from 'react-intl'
import { Show } from '~/components/commons'
import { useSearchParamsHandler } from '~/contexts/FilterContext'

import 'flatpickr/dist/plugins/monthSelect/style.css'

export default function DatePicker() {
  const intl = useIntl()
  const selectedProject = useSelector(state => state.user.selectedProject)
  const { query, setQuery } = useSearchParamsHandler()
  const [invalidPeriod, setInvalidPeriod] = useState(false)

  const period = useMemo(() => {
    const currentMonth = new Date().getMonth()
    const currentYear = new Date().getFullYear()
    const defaultYear = currentMonth === 0 ? currentYear - 1 : currentYear
    const defaultMonth = currentMonth === 0 ? 12 : currentMonth
    const [year, month] =
      query.period?.split('-') ||
      selectedProject.id === '7f77bb82-2e71-4848-b13b-be245cab9cda'
        ? [2024, 7]
        : [defaultYear, defaultMonth]

    return year && month ? new Date(`${year}/${month}/1`) : new Date()
  }, [selectedProject.id])

  const setPeriod = dates => {
    if (dates.length !== 1) return

    if (isAfter(dates[0], new Date())) {
      setInvalidPeriod(true)
    } else {
      const period = format(dates[0], 'yyyy-MM')
      setQuery('period', period)
      setInvalidPeriod(false)
    }
  }
  return (
    <>
      <Show condition={invalidPeriod}>
        <small className="text-danger pl-3">
          <FormattedMessage id="Invalid Date! You can't choose a future month" />
        </small>
      </Show>
      <InputGroup
        style={{
          flexWrap: 'nowrap',
          alignItems: 'center',
          alignSelf: 'stretch',
        }}
      >
        <InputGroupAddon addonType="append">
          <Icon.Calendar size={24} className="mr-1" />
        </InputGroupAddon>
        <DateTimePicker
          id="period-date"
          style={{
            display: 'flex',
            flex: 1,
            minHeight: '40px',
            alignSelf: 'stretch',
          }}
          value={period}
          onChange={setPeriod}
          invalid={invalidPeriod}
          options={{
            prevArrow: '',
            nextArrow: '',
            plugins: [
              new MonthSelectPlugin({
                shorthand: true,
                dateFormat: 'F, Y',
                altFormat: 'm-Y',
              }),
            ],
          }}
          placeholder={intl.formatMessage({ id: 'Filter by period' })}
        />
      </InputGroup>
    </>
  )
}
